import {
  FormFieldInternalLookupResponseDTO,
  FormFieldValueDTO,
} from '@/api/base/DTOs';
import { config } from '@/forms/config';

import { RadioOption, SelectOption } from '@/forms/typings';

import { getStoreState } from '@/store';
import { ILookup } from '@/typings';

/** The Select value standing for one internal lookup entry. */
export const toInternalLookupOptionValue = (
  lookupTypeID: number,
  entryId: string,
): string =>
  `${config.internalLookupPrefix}${lookupTypeID}${config.internalLookupPrefix}${entryId}`;

/** Options for an internal-lookup field: the listed entries, then saved answers the list no longer offers. */
export const adaptInternalLookupResponseToOptions = (
  internalLookupResponse: FormFieldInternalLookupResponseDTO,
  savedValues?: FormFieldValueDTO[],
): RadioOption[] | SelectOption[] | undefined => {
  const lookups = getStoreState().lookup.internalLookups;

  if (Object.keys(lookups).length === 0) return undefined;

  const lookup: ILookup[] | undefined =
    lookups?.[internalLookupResponse.lookupTypeID];

  if (!lookup) return undefined;

  const toOptionValue = (entryId: string) =>
    toInternalLookupOptionValue(internalLookupResponse.lookupTypeID, entryId);

  const options = lookup.map(lookupValue => ({
    value: toOptionValue(lookupValue.id),
    label: internalLookupResponse.useShortName
      ? lookupValue.shortName || ''
      : lookupValue.name,
  }));

  // Disabled entries leave the list; answers saved before then keep their saved name.
  const listedIds = new Set(lookup.map(lookupValue => lookupValue.id));
  savedValues?.forEach(savedValue => {
    const { lookupID, value } = savedValue;
    if (!lookupID || listedIds.has(lookupID) || !value?.trim()) return;

    listedIds.add(lookupID);
    options.push({ value: toOptionValue(lookupID), label: value });
  });

  return options;
};
